import React from "react";
import { Form } from "react-final-form";
import StepFormFields from "../../../booking/components/bag_transport/StepFormFields";
import { validate } from "../../../../data/booking/validators/bag_transport";
import { serviceName, serviceIconUrl } from "../../../../data/booking/constants/service_types";
import { useTranslation } from "react-i18next";
import { setStep, setStop, setValue } from "../../../booking/components/bag_transport/mutators";
import { FormHeading } from "../../../shared/components/Typograhy";
import { Breadcrumb } from "../form/Breadcrumb";
import { BackButton, ButtonArea, NextButton } from "../../../shared/components/Buttons";
import SlideInAnimation from "../../../shared/components/SlideInAnimation";

const FirstStepForm = ({
    serviceType,
    route,
    handleSubmit,
    onClickBack,
    initialValues,
}) => {
    const { t } = useTranslation();

    return (
        <>
            <SlideInAnimation appear={true}>
                <Breadcrumb title={serviceName(serviceType)} />
                <FormHeading
                    title={t("booking.bag_transport_first_step")}
                />

                <Form
                    onSubmit={handleSubmit}
                    keepDirtyOnReinitialize={true}
                    validate={validate}
                    initialValues={initialValues}
                    mutators={{
                        setStep,
                        setStop,
                        setValue,
                    }}
                >
                    {({
                        handleSubmit,
                        pristine,
                        form,
                        submitting,
                        invalid,
                        form: { mutators },
                    }) => (
                        <form onSubmit={handleSubmit} className="">
                            <StepFormFields
                                form={form}
                                routeId={route.id}
                                mutators={mutators}
                            />

                            <ButtonArea>
                                <BackButton onClick={onClickBack}>
                                    {t("booking.back")}
                                </BackButton>
                                <NextButton
                                    classname="ml-auto"
                                    disabled={pristine || submitting || invalid}
                                    type="submit"
                                >
                                    {t("booking.next")}
                                </NextButton>
                            </ButtonArea>
                        </form>
                    )}
                </Form>
            </SlideInAnimation>
        </>
    );
};

export default FirstStepForm;
